import client from "../libs/HttpClient";

class TheMeticDemoService {
  static getTheMaticDemoData() {
    return client.get("/thematic_demo");
  }
}

export { TheMeticDemoService };
